import Vue from 'vue'

export const PhrasesAJAX = new Vue({
    data: {
        errors: {
            not_found: 'Page not found',
            server_busy: 'Server is busy. Try again later.',
        },
    },
});